// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>29</span>&nbsp;&nbsp;You also shall light my candle;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord my God shall make my darkness to be bright.<br> </p> </div></div>";
// Exports
module.exports = code;